import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { JobTagsComponent } from './manage-job-tag.component';

const routes: Routes = [{ path: '', component: JobTagsComponent, data: { title: 'Job Tags' } }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class JobTagRoutingModule {}

@NgModule({
  imports: [
    JobTagRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [JobTagsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class JobTagModule {}
